//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocRow from './sub/DocumentRow.vue';
export default {
	name: "DocumentTable",
	props: {
		form: {
			type: Object,
			required: true
		},
		doc: {
			type: Object,
			required: true
		},
		is_new: {
			type: Boolean,
			required: true
		},
		allow_edit: {
			type: Boolean,
			required: true
		},
		set_value: {
			type: Function,
			required: true
		},
	},
	data() {
		const { doc } = this;

		if (!doc.document_table) {
			doc.document_table = new Array();
		}

		const data = {
			rows: this.doc.document_table,
		};

		return data;
	},
	components: {
		DocRow,
	},
	methods: {
		add_row() {
			const { rows } = this;
			const new_row = {
				document: "",
				type: "",
			};
			rows.push(new_row);
		},
		delete_row(index) {
			const { rows } = this;
			const start = index - 1;
			const delete_count = 1;
			rows.splice(start, delete_count);4
		},
	}
	// mounted() {
	// 	const { document_table } = this.doc;

	// 	for (const row of document_table) {
	// 		this.rows.push(row);
	// 	}
	// },
}
